import { app } from '../../../../../../app';
import { Controller } from './share-shared-folder.controller';

app.component('companySharingCenterSharedFoldersManageShare', {
    bindings: {
		companyId: '<',
		sharedFolder:'<',
        sharedFolderId: '<',
        users: '<',
        sharedLabels: '<'
    },
    controller: Controller,
    templateUrl: require('./share-shared-folder.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/share/share-shared-folder.component.js